// tslint:disable: no-output-on-prefix
import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {NgToolsService} from "../../ng-util/ng-tools.service";

@Component({
    selector: "ng-paginator",
    templateUrl: "./ng-paginator.component.html",
    styleUrls: ["./ng-paginator.component.less"]
})
export class NgPaginatorComponent implements OnInit, AfterViewInit {
    @Input() get totalRecords(): number {
        return this._totalRecords;
    }

    @Input() get rows(): number {
        return this._rows;
    }

    @Input() initialPage: number;
    // for backend paginate, should set it to be false
    @Input() isFrontendPaginate = true;
    @Output() onPageChange: EventEmitter<number> = new EventEmitter();

    constructor(private toolsSvc: NgToolsService) {
    }

    private _rows = 0;
    set rows(val: number) {
        this._rows = val;
        this.init();
    }

    private _totalRecords = 0;
    set totalRecords(val: number) {
        this._totalRecords = val;
        this.init();
    }

    private totalPages: number;
    private currentPage = 1;
    private currentPageInput: number;

    private disabledEls = {
        first: true,
        prev: true,
        next: false,
        last: false
    };

    ngOnInit() {
        this.init();
    }

    ngAfterViewInit() {
        // Using setTimeout to make sure the view is checked to avoid reference errors in parent component's viewChild()
        this.toolsSvc.setTimeout(() => {
            if (this.initialPage) {
                if (typeof this.initialPage === "string") {
                    this.initialPage = parseInt(this.initialPage, 10);
                }
                if ( this.isFrontendPaginate) {
                    this.changePage(this.initialPage);
                } else {
                    this.currentPage = this.initialPage;
                    this.updateStatus();
                    this.resetInput();
                }
            }
        }, 0);
    }

    private init() {
        if (this.rows > 0) {
            this.totalPages = Math.ceil(this.totalRecords / this.rows);
            this.currentPageInput = this.currentPage;
        }
        this.updateStatus();
    }

    private updateStatus() {
        const disFirst = this.totalPages === 0 || Number(this.currentPage) === 1;
        this.disabledEls.first = disFirst;
        this.disabledEls.prev = disFirst;

        const disLast = this.totalPages === 0 || Number(this.currentPage) === this.totalPages;
        this.disabledEls.next = disLast;
        this.disabledEls.last = disLast;
    }

    private sendPage() {
        this.currentPageInput = this.currentPage;
        this.updateStatus();
        let firtRowOfPage: number = this.rows * (this.currentPage - 1);
        if (!this.isFrontendPaginate) {
            firtRowOfPage = this.currentPage;
        }
        this.onPageChange.emit(firtRowOfPage);
    }

    private first() {
        this.currentPage = 1;
        this.sendPage();
    }

    private next() {
        if (!this.disabledEls.next) {
            this.currentPage++;
            this.sendPage();
        }
    }

    private prev() {
        if (!this.disabledEls.prev) {
            this.currentPage--;
            this.sendPage();
        }
    }

    private last() {
        if (!this.disabledEls.last) {
            this.currentPage = this.totalPages;
            this.sendPage();
        }
    }

    private resetInput() {
        this.currentPageInput = this.currentPage;
    }

    getPage(): number {
        return this.currentPage;
    }

    changePage(page: number) {
        if (page > 0 && page <= this.totalPages) {
            this.currentPage = page;
            this.sendPage();
        }
        this.resetInput();
    }
}
